import config from "@genai/config";

export const toApiUrl = (route: string | URL | Request) => {
  return `${config.endpointUrl}${route}`;
};
